import { useEffect } from "react";

const ColorPicker = ({
  type,
  name,
  register,
  defaultValue,
  errors,
  label,
  autoComplete,
  valueAsNumber,
}) => {
  useEffect(() => {}, [defaultValue]);
  return (
    <>
      <div className="input-container flex gap-3">
        <label htmlFor={name} className="block text-text-1/90 font-medium">
          {label}
        </label>
        <input
          className="w-20 px-4  border-b-2 text-base rounded-none bg-content  focus:outline-none focus:border-b-primary text-text-1/75 border-none"
          type={type}
          min={0}
          // placeholder={placeholder}
          autoComplete={autoComplete ? autoComplete : ""}
          {...register(name, { valueAsNumber })}
          defaultValue={defaultValue ? defaultValue : ""}
          // step={type === "number" ? 0.01 : ""}
        />
        {/* {errors && <p className="input-error-text">{errors.message}</p>} */}
        {
          <p className="text-red-400 text-xs text-wrap w-fit">
            {errors && errors.message} <span className="invisible">Sample</span>
          </p>
        }
      </div>
    </>
  );
};

export default ColorPicker;
